/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import * as ActionTypes from './ActionTypes';
import { setFolderPermissions } from '../api/Partitioning';
import { partitioningAlerts } from '../utils/notifications';
import { RequestStatus } from '../Constants';
export function updatePartitioning(folderIds, teamIds) {
  return dispatch => {
    dispatch({
      type: ActionTypes.CHANGE_FOLDER_PARTITIONING_ATTEMPTED,
      status: RequestStatus.PENDING,
      folderIds
    });
    setFolderPermissions(folderIds, teamIds).then(() => {
      dispatch({
        type: ActionTypes.CHANGE_FOLDER_PARTITIONING_SUCCEEDED,
        folderIds,
        teamIds,
        meta: {
          notification: partitioningAlerts.success
        },
        status: RequestStatus.SUCCEEDED
      });
    }, error => {
      dispatch({
        type: ActionTypes.CHANGE_FOLDER_PARTITIONING_FAILED,
        meta: {
          notification: partitioningAlerts.error
        },
        status: RequestStatus.FAILED
      });
      throw error;
    });
  };
}